import { render, staticRenderFns } from "./HeaderImage.vue?vue&type=template&id=2b0b1529&scoped=true&"
import script from "./HeaderImage.vue?vue&type=script&lang=js&"
export * from "./HeaderImage.vue?vue&type=script&lang=js&"
import style0 from "./HeaderImage.vue?vue&type=style&index=0&id=2b0b1529&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0b1529",
  null
  
)

export default component.exports